"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
export default function ReadyToCollaborateCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative bg-background py-24 px-6 overflow-hidden">
      <div className="container mx-auto max-w-3xl text-center">
        <div className={`transition-all duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-6">
            Ready to Bring Your Vision to Life?
          </h2>
          
          <p className="text-lg md:text-xl text-muted mb-10 leading-relaxed">
            Partner with Flex DPS to transform your innovative concepts into market-ready products. Our expert team is here to guide you every step of the way.
          </p>

          <Link to="/ContactPage">
            <Button size="lg" className="group relative overflow-hidden bg-accent text-white hover:bg-accent-hover active:bg-accent-active hover:shadow-medium hover:scale-[1.02] active:scale-100 transition-all duration-[250ms] ease-[cubic-bezier(0.34,1.56,0.64,1)] px-8 py-6 text-base font-semibold rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
              <span className="relative z-10 flex items-center gap-2">
                Contact Us
                <ArrowRight className="size-5 group-hover:translate-x-1 transition-transform duration-[250ms]" />
              </span>
              <span className="absolute inset-0 bg-white/20 rounded-full scale-0 group-active:scale-100 transition-transform duration-300 ease-out" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}